import { render, staticRenderFns } from "./EfsMdChickenPriceModal.vue?vue&type=template&id=8a7ce2f4&"
import script from "./EfsMdChickenPriceModal.vue?vue&type=script&lang=js&"
export * from "./EfsMdChickenPriceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports